import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || `${window.location.origin}/`;

const axiosInstance = axios.create({
  timeout: 30000,
  headers: {
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");

  config.headers = config.headers || {};

  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }

  let url = config.url;
  if (!url) return config;

  // Handle absolute URLs
  if (/^https?:\/\//i.test(url)) {
    try {
      const parsed = new URL(url);

      // Only normalize if it's same-origin (your API)
      if (parsed.origin === window.location.origin) {
        url = `${parsed.pathname}${parsed.search}`;
      } else {
        return config; // external URL → leave untouched
      }
    } catch {
      return config;
    }
  }

  // Ensure /api prefix exactly once
  if (!url.startsWith("/api")) {
    url = url.startsWith("/") ? `/api${url}` : `/api/${url}`;
  }

  config.url = url;
  return config;
});

export default axiosInstance;
